import { styled } from "solid-styled-components";
export const PreviewWrapper = styled.div`
  position: absolute;
  right: 10px;
  bottom: 20px;
`;
